import React from 'react'

function detail() {
  return (
    <div>

    </div>
  )
}

export default detail
